import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  MenuItem,
  Select,
  FormControl,
  InputBase,
  CircularProgress,
} from "@mui/material";
import { useQuery } from "react-query";
import axiosInstance from "../../helpers/AxiosInstance";
import fileDownload from "js-file-download";
const StyledSelect = styled(InputBase)(() => ({
  " .MuiInputBase-input": {
    position: "relative",
    border: "1px solid var(--primary-color)",
    fontSize: 13,
    paddingBlock: "12px",
    paddingLeft: "10px",
    width: "117px",
    fontWeight: "bold",
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #0000005E",
  },
  ".MuiSelect-iconOutlined": {
    color: "var(--primary-color)",
  },
}));
export default function NewPrintBtn({ data, print, setLoading }) {
  const instance = axiosInstance();
  const [localLoading, setLocalLoading] = useState(false);

  const { data: labelData } = useQuery(
    "getLabels",
    async () => {
      const response = await instance.get("/GetPDFTemplates");
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  setLoading = setLoading ? setLoading : () => {};
  const { t } = useTranslation("uploadExcel");
  const [value, setValue] = useState("");

  const handleExport = async (templateID) => {
    if (!data || (Array.isArray(data) && data.length === 0)) return;

    setLocalLoading(true);
    setLoading(true);

    let craftedData = {
      awBs: [],
    };

    if (typeof data === "number") {
      craftedData.pickupNo = data;
      craftedData.awBs = [];
    } else {
      craftedData.awBs = typeof data === "string" ? [data] : data;
      delete craftedData.pickupNo;
    }

    try {
      const response = await instance.post(
        "ExportPDF",
        {
          templateID: templateID,
          ...craftedData,
        },
        {
          responseType: "blob",
          withCredentials: true, // Enable cookies for template export
        },
      );

      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      const day = new Date().getDate();
      const hour = new Date().getHours();
      const minutes = new Date().getMinutes();
      const seconds = new Date().getSeconds();
      const milliSec = new Date().getMilliseconds();

      const labelName =
        labelData?.find((l) => l.templateID === templateID)?.name || "Label";

      fileDownload(
        response.data,
        `${labelName} - ${day}/${month}/${year} ${hour}:${minutes}:${seconds}:${milliSec}.pdf`,
      );
    } catch (error) {
      console.error("Export PDF error:", error);
    } finally {
      setLocalLoading(false);
      setLoading(false);
      setValue("");
    }
  };

  const handleChange = (event) => {
    const templateID = event.target.value;
    if (templateID) {
      handleExport(templateID);
    }
  };

  return (
    <div>
      <FormControl>
        <Select
          input={<StyledSelect defaultValue={""} />}
          value={value}
          id="export"
          onChange={handleChange}
          displayEmpty
          disableunderline="true"
          inputProps={{ "aria-label": "Without label" }}
          disabled={localLoading}
        >
          <MenuItem value="" disabled>
            <em>
              {localLoading ? <CircularProgress size={14} /> : t("export_pdf")}
            </em>
          </MenuItem>
          {labelData?.map((label) => (
            <MenuItem key={label.templateID} value={label.templateID}>
              {label.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
